import axios from '../utils/request.js'

export function getClarificationMessage(pageNum,pageSize) {
    return axios({
        url: '/zy3/'+pageNum+'/'+pageSize,
        method: 'get',
        withCredentials: true
    })
}

// 查询澄清公告
export function searchClarificationMessage(searchVo) {
    return axios({
        url: '/zy3/search',
        method: 'POST',
        data: searchVo,
        withCredentials: true
    })
}
